import React, { useEffect } from 'react'
import Modal from 'react-bootstrap/Modal'
import Alert from 'react-bootstrap/Alert'
import Button from 'react-bootstrap/Button'


function EliminarUsuario(props) {
	const { usuario, cancelar, mostrar, eliminar } = props

	const handleClose = () => {
		cancelar()
	}

	useEffect(() => {

	}, [usuario])
	
	return (
		<Modal show={mostrar} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>Eliminar Usuario</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Alert variant="danger">
					Está a punto de eliminar el usuario <strong>{`${usuario?.nombre} ${usuario?.apellido}`}</strong>. Esta acción no se puede deshacer.
				</Alert>
				<p>¿Está seguro que desea continuar?</p>
			</Modal.Body>
			<Modal.Footer>
				<Button variant="outline-tertiary" onClick={handleClose}>
					Cancelar
				</Button>
				<Button variant="danger" onClick={() => eliminar(usuario?.id)}>
					Eliminar
				</Button>
			</Modal.Footer>
		</Modal>
	)
}

export default EliminarUsuario